import { Box, InputAdornment, Typography } from '@mui/material'
import { Calendar, X } from 'lucide-react'
import React, { forwardRef } from 'react'
import { makeStyles } from 'tss-react/mui'

// ...

export const DatePickerInput = forwardRef<
  HTMLDivElement,
  {
    onClick?: () => void
    value?: string
    placeholder?: string
    onClear?: () => void
  }
>(({ onClick, value, placeholder, onClear }, ref) => {
  const { classes } = useStylesDatePicker()

  return (
    <Box
      ref={ref}
      className={classes.fakeInput}
      onClick={onClick}
      tabIndex={0}
      role="button"
      //aria-label="Select date and time"
    >
      <Typography variant="body1" color={value ? 'text.primary' : 'text.disabled'} sx={{ fontSize: '1.125rem' }}>
        {value || placeholder || 'Pick-up date and time'}
      </Typography>

      {value ? (
        <Box
          onClick={(e) => {
            e.stopPropagation()
            onClear?.()
          }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            color: 'text.secondary',
            '&:hover': { color: 'text.primary' },
          }}
        >
          <X size={16} />
        </Box>
      ) : (
        <InputAdornment position="end">
          <Calendar size={'1.25rem'} />
        </InputAdornment>
      )}
    </Box>
  )
})

const useStylesDatePicker = makeStyles()((theme) => ({
  fakeInput: {
    width: '100%',
    minHeight: '3rem',
    borderRadius: 4,
    backgroundColor: '#FFF',
    border: `1px solid ${theme.palette.divider}`,
    padding: '0.5rem 1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '&:hover': {
      borderColor: theme.palette.text.primary,
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: '-2px',
    },
  },
}))
